const ALLOWLIST = new Set([
  "adminuser@svb.com",
  "causer@svb.com",
  "csuser@svb.com",
  "rmuser@svb.com",
]);

export const isRestrictedEmail = (email: string): boolean => {
  const e = email.trim().toLowerCase();
  const isBlockedDomain = /@(svb\.com|firstcitizens\.com)$/i.test(e);
  const isAllowed = ALLOWLIST.has(e);
  return isBlockedDomain && !isAllowed;
};